module.exports = __webpack_public_path__ + "img/uparrow.38b86991.svg";